import React from 'react'
import { handleImgixUrl } from '@kogk/common'
import cn from 'classnames'
import { AspectRatioBox } from '..'
import { getTrimmedExcerpt } from '../utils'

export interface CardDetailsType {
  prismicId?: string
  url?: string
  name: {
    text: string
  }
  excerpt: {
    html: string
  }
  about?: {
    html: string
  }
  content?: {
    html: string
  }
  image: {
    alt: string
    url: string
  }
  featuredImage?: {
    alt: string
    url: string
  }
  website?: {
    url: string
  }
  tags?: string[]
  partner?: boolean
  category?: string
}

const Card: React.FC<{
  card: CardDetailsType
  smallerImage?: boolean
  image: {
    url: string
    alt: string
  }
  onRenderFootnote?: (item: string, idx: number) => React.ReactNode
  containerClass?: string
  hasTags?: boolean
  maxTags?: number
  spreadContent?: boolean
  excerptNoMaxHeight?: boolean
  excerptMaxLen?: number
  footnoteExtraStyle?: React.CSSProperties
}> = ({
  card,
  smallerImage,
  image,
  onRenderFootnote = null,
  containerClass,
  hasTags,
  maxTags = 3,
  spreadContent,
  excerptNoMaxHeight,
  excerptMaxLen,
  footnoteExtraStyle
}) => {
  const excerpt = getTrimmedExcerpt('p', card.excerpt, excerptMaxLen)

  return (
    <div className={cn('card', containerClass)}>
      <div className='card__container p-2'>
        {image.url && (
          <AspectRatioBox ratio='widescreen' containerClass='card__img'>
            <img
              style={!smallerImage ? { objectFit: 'contain' } : { padding: '5px 25px', objectFit: 'contain' }}
              src={handleImgixUrl(image.url).url()}
              alt={image.alt || 'card thumbnail'}
            />
          </AspectRatioBox>
        )}
        <h5 className={cn('mt-2 text-left pb-1')}>{card.name.text}</h5>
        {excerpt && (
          <div
            dangerouslySetInnerHTML={{ __html: excerpt.html }}
            className={cn(
              'text-left card__excerpt parag--sm pb-2',
              spreadContent ? 'position-absolute' : '',
              excerptNoMaxHeight ? 'card__excerpt--noMaxHeight' : ''
            )}
          />
        )}
        {card.tags && onRenderFootnote && (
          <div className={cn('card__footnote pt-3 pb-2 pr-2', hasTags ? 'card__footnote--tags' : '')} style={ footnoteExtraStyle && footnoteExtraStyle}>
            {card.tags.map((tag, idx) => idx < maxTags && tag && onRenderFootnote(tag, idx))}
          </div>
        )}
      </div>
    </div>
  )
}

export default Card
